import withInjection from '@piconetworks/with-injection'
import CheckoutWithPlan from 'common/components/CheckoutWithPlan'

const mapStateToProps = (state, props) => {
    const { id, optionId, popupId } = props?.router?.query || {}
    return {
        ...props,
        wizardName: id,
        optionId,
        popupId,
    }
}

const InjectedCheckout = withInjection(CheckoutWithPlan, {
    mapStateToProps,
})

export default InjectedCheckout
